import React, { FC, useState } from "react";
import { Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useVrmSaleRoDetailModel } from "../vrmBillSaleRoModel";
import { IDetailList } from "../vrmBillSaleRoType";
import useNavModel, { RouterParamType } from '@/model/navModel';
import { useVrmPurchaseRoDetailsModel } from "../../vrmBillPurchaseRo/vrmBillPurchaseRoModel"

export const TableBox: FC<RouterParamType> = () => {
    const {
        detailLookList,
    } = useVrmSaleRoDetailModel();
    const { goToSaleDetail } = useVrmPurchaseRoDetailsModel()
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { branch } = detailsInfo
    const columns: ColumnsType<IDetailList> = [
        {
            title: '序号',
            width: 80,
            fixed: "left",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '销售单号',
            width: 120,
            dataIndex: 'saleCode',
            fixed: "left",
            render: (t) => <Tooltip placement="topLeft" title={t} arrowPointAtCenter>
                <p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); goToSaleDetail(t,branch) }}>{t}
                </p></Tooltip>
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            fixed: "left",
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text}</p></Tooltip>,
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            fixed: "left",
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,

        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '销售数量',
            width: 160,
            dataIndex: 'saleNum',
        }, {
            title: '销售单价',
            width: 160,
            dataIndex: 'salePrice',
        }, {
            title: '退货数量',
            width: 160,
            dataIndex: 'num',

        }, {
            title: '退货单价',
            width: 160,
            dataIndex: 'price',

        }, {
            title: '退货金额',
            width: 160,
            dataIndex: 'amount',
        }, {
            title: '已退数量',
            width: 160,
            dataIndex: 'sreturnNum',
        }, {
            title: '仓库',
            width: 160,
            dataIndex: 'warehouseName',
        }, {
            title: '货位',
            width: 160,
            dataIndex: 'shelfCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',

        }
    ];

    return (
        <YhBox title="配件信息" style={{ marginBottom: "75px" }}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.materialCode as string}
                columns={columns}
                dataSource={detailLookList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}